"use client"

import { useQueryState } from "nuqs"
import { loginSearchParams } from "../searchParams"
import { LoginForm } from "./LoginForm"

// Separate from LoginForm so the nuqs read (`useSearchParams` under the hood)
// can have its own <Suspense> boundary, with a plain <LoginForm /> as the
// fallback — the standard Next.js pattern for `useSearchParams` in a Client
// Component.
export const LoginFormWithRedirect = () => {
  const [redirectTo] = useQueryState("redirect", loginSearchParams.redirect)
  return <LoginForm redirectTo={redirectTo} />
}
